module.exports = __webpack_public_path__ + "img/hicks2.63667d46.jpg";